import React from "react";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const SureModal = ({ isOpen, onClose,onConfirm, title, actionType }) => {
  const isDeactivate = actionType === "Deactivate";
  const { COLORS } = useThemeMode();
  
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ background: COLORS.primary }}>
          <div className="modal-body text-center">
            <span className="fw-normal" style={{ color: COLORS.text }}>
              {title === "User Status" ? (
                <>
                  Are you sure you want to <b>{actionType?.toLowerCase()}</b> this user account? <br />
                  {isDeactivate
                    ? "Once deactivated, the user will no longer be able to sign in or access the application until the account is reactivated."
                    : "Once activated, the user will be able to sign in and access all features and permissions assigned to their role."}
                </>
              ) : (
                <>
                  Are you sure you want to <b>{actionType?.toLowerCase()}</b> {title}? <br />
                  {isDeactivate
                    ? `Deactivating this ${title} will make it unavailable for use in the application until it is reactivated.`
                    : `Activating this ${title} will make it available for use in the application wherever applicable.`}
                </>
              )}
            </span>
          </div>
          <div className="modal-footer d-flex flex-column justify-content-center border-0">
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onConfirm}
              style={{ background: COLORS.button, color: COLORS.background }}
            >
              {title === "User Status" ? `${actionType} User Account` : `${actionType} ${title}`}
            </button>
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onClose}
              style={{ background: COLORS.background, color: COLORS.button }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SureModal;